<template>
  <div :class="[prefixCls + '__btn']">
    <t-button size="sm" @click.native="$_onPopperCancel">{{ cancelText }}</t-button>
    <t-button color="primary" size="sm" @click.native="$_onPopperConfirm">{{ confirmText }}</t-button>
  </div>
</template>
<script>
import { TButton } from '../button'
import { PREFIX_CLASS } from '../../utils/constants'
const PREFIXCLS = `${PREFIX_CLASS}popover`
export default {
  name: 'TPopperButton',
  components: {
    TButton
  },
  props: {
    cancelText: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prefixCls: PREFIXCLS
    }
  },
  methods: {
    $_onPopperCancel() {
      this.$emit('on-cancel')
    },
    $_onPopperConfirm() {
      this.$emit('on-confirm')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/poptip/popper-button.vue